

























import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';

import LoadingSpinner from '@reciprocity/loading-spinner';
import { loadAuthenticationSettings, saveAuthenticationSettings } from '@/utils/crudActions';

import { AuthMode, AuthenticationSettings } from './types';
import AuthenticationTypeSelection from './components/AuthenticationTypeSelection.vue';
import SsoListing from './components/SsoListing.vue';

export default Vue.extend({
  name: 'AuthenticationSettingsPage',
  components: {
    AuthenticationTypeSelection,
    LoadingSpinner,
    SsoListing,
  },
  data() {
    return {
      loading: <boolean>true,
      authenticationSettings: <AuthenticationSettings>{
        selectedAuthModes: [AuthMode.Standalone, AuthMode.Google],
        lastLoggedInWithSaml: null,
        lastEditionDateSaml: null,
        debugMode: false,
        samlConfigurationReady: false,
        samlGroupsEnabled: false,
        overrideEnableStandaloneLogin: false,
        overrideEnableGoogleLogin: false,
      },
    };
  },
  computed: {
    ...mapGetters(['routes']),
  },
  created() {
    this.setPageTitle({ title: 'Authentication settings' });
    this.loadSettings();
  },
  methods: {
    ...mapActions({
      setPageTitle: 'setPageTitle',
      showAlert: 'alerts/show',
    }),
    async loadSettings() {
      try {
        this.loading = true;
        this.authenticationSettings = {
          ...this.authenticationSettings,
          ...(await this.loadAuthenticationSettings()),
        };
      } catch (error) {
        this.showAlert(error);
      } finally {
        this.loading = false;
      }
    },
    async updateAuthenticationSettings(authenticationSettings: AuthenticationSettings) {
      this.authenticationSettings = authenticationSettings;
      try {
        this.authenticationSettings = {
          ...this.authenticationSettings,
          ...(await this.saveAuthenticationSettings(authenticationSettings, this.csrfToken)),
        };
        this.showAlert({
          type: 'success',
          message: 'Settings saved successfully',
        });
      } catch (error) {
        this.showAlert(error);
      }
    },
    loadAuthenticationSettings,
    saveAuthenticationSettings,
  },
});
